// Inventory Outlets State

export default {
  outletsList: [],
  outletInfo: {},
  fullOutletsList: []
}
